module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop3.1260765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop3.jpg
// module id = 9+6o
// module chunks = 0